module.exports = __webpack_public_path__ + "img/75758.dac31134.svg";